import styled from 'styled-components'
import { Card as AntCard } from 'antd'

/* 整体卡片容器 */
export const Card = styled(AntCard)`
  max-width: 640px;
  margin: 1rem auto;
  border-radius: 20px;
  border: none;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  .ant-card-body {
    padding: 1.5rem 1.5rem 1.75rem;
  }

  @media (max-width: 768px) {
    margin: 0.75rem;
    border-radius: 16px;

    .ant-card-body {
      padding: 1rem;
    }
  }
`

/* 卡片头部 */
export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 1.25rem 1.5rem 0.75rem;

  .ant-text {
    font-size: 1.125rem;
    color: #1fc7d4;
    position: relative;
    padding-left: 0.75rem;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 1.1em;
      border-radius: 4px;
      background: #1fc7d4;
    }
  }

  @media (max-width: 768px) {
    padding: 1rem 1rem 0.5rem;
  }
`

/* 卡片主体 */
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

/* 每个表单区块 */
export const SenderTokenItem = styled.div`
  width: 100%;

  &.flex_sb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  /* 代币地址与小数的左右布局 */
  .item {
    display: flex;
    gap: 1rem;
    align-items: flex-end;

    .itemleft {
      flex: 1;
      min-width: 0;
    }

    .itemright {
      width: 100px;
      flex-shrink: 0;
    }
  }

  /* 收款地址标题行 */
  .updateTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
    margin-bottom: 0.75rem;

    .ant-text {
      cursor: pointer;
      color: #1fc7d4;
      font-size: 0.8125rem;
      transition: color 0.2s;

      &:hover {
        color: #18a7b3;
      }
    }
  }

  /* 通用输入框/文本域美化 */
  .ant-input,
  .ant-input-affix-wrapper,
  textarea.ant-input {
    border-radius: 10px;
    border: 1px solid #e6ebf5;
    padding: 0.625rem 0.875rem;
    font-size: 0.875rem;
    transition: all 0.2s ease;

    &:hover {
      border-color: #b8e6eb;
    }

    &:focus,
    &.ant-input-focused {
      border-color: #1fc7d4;
      box-shadow: 0 0 0 3px rgba(31, 199, 212, 0.12);
    }
  }

  textarea.ant-input {
    min-height: 180px;
    line-height: 1.6;
    resize: vertical;
  }

  /* 红色提示文字 */
  .colorred {
    color: #ff5a5f;
    cursor: pointer;
    font-size: 0.8125rem;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.75;
    }
  }

  /* 下一步按钮 */
  .ant-btn {
    width: 100%;
    height: 46px;
    border-radius: 12px;
    font-size: 0.9375rem;
    font-weight: 600;
    background: linear-gradient(135deg, #1fc7d4, #18a7b3);
    border: none;
    box-shadow: 0 4px 14px rgba(31, 199, 212, 0.3);
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(135deg, #18a7b3, #148f9a);
      box-shadow: 0 6px 18px rgba(31, 199, 212, 0.4);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(31, 199, 212, 0.3);
    }
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    .item {
      flex-direction: column;
      align-items: stretch;
      gap: 0.75rem;

      .itemright {
        width: 100%;
      }
    }

    .updateTitle {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    &.flex_sb {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`